import request from '@/utils/request'
import type { TestServerCdkeyRecordType } from './types'

export function getTestServerCdkeyApi() {
  return request<TestServerCdkeyRecordType | null>({
    url: 'test-reward/getTestServerCdkey',
  })
}

export function lotteryTestSeverCdkeyApi() {
  return request<string>({
    url: 'test-reward/lotteryTestSeverCdkey',
    method: 'POST',
  })
}
